import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type Store = {
  stressListParams: {
    cusId: string | null,
    pageNum: number,
  },
  setStressListParams: (name: any, value: any) => void,

  stressList: [],
  setStressList: (by: []) => void,

  stressListCount: number,
  setStressListCount: (by: number) => void,

  targetInfo: [],
  setTargetInfo: (by: []) => void,
  targetSurvey: [],
  setTargetSurvey: (by: []) => void,

  questionsList: [],
  setQuestionsList: (by: []) => void,

  resultList: [],
  setResultList: (by: []) => void,

  surveyAssigned: {},
  setSurveyAssigned: (by: {}) => void,

  familyInfo: {},
  setFamilyInfo: (by: {}) => void,

  surveyInfoList: [],
  setSurveyInfoList: (by: []) => void,

  clear: () => void
  modalClear: () => void
  resultClear: () => void
  /*  reservationId: string
    setReservationId: (by: string) => void*/
}

const useStressStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        stressListParams: { cusId: localStorage.getItem('userCusID'), pageNum: 0 },
        setStressListParams: (name: any, value: any) => set((state: any) => {
          state.stressListParams[name] = value;
          return {}
        }),

        stressList: [],
        setStressList: (by: []) => set((state) => ({ stressList: by })),

        stressListCount: 0,
        setStressListCount: (by: number) => set((state) => ({ stressListCount: by })),

        targetInfo: [],
        setTargetInfo: (by: []) => set((state) => ({ targetInfo: by })),
        targetSurvey: [],
        setTargetSurvey: (by: []) => set((state) => ({ targetSurvey: by })),

        // 설문조사 리스트
        questionsList: [],
        setQuestionsList: (by: []) => set((state) => ({ questionsList: by })),

        // 설문조사 결과 리스트
        resultList: [],
        setResultList: (by: []) => set((state) => ({ resultList: by })),

        // 설문 정보
        surveyAssigned: {},
        setSurveyAssigned: (by: {}) => set((state) => ({ surveyAssigned: by })),

        // 고객 정보
        familyInfo: {},
        setFamilyInfo: (by: {}) => set((state) => ({ familyInfo: by })),

        // 설문 결과 정보
        surveyInfoList: [],
        setSurveyInfoList: (by: []) => set((state) => ({ surveyInfoList: by })),

        /*  reservationId: '',
          setReservationId: (by: string) => set((state) => ({ reservationId: by })),*/

        clear: () => set((state) => ({
          stressList: [],
          stressListCount: 0,
          stressListParams: { cusId: localStorage.getItem('userCusID'), pageNum: 0 },
        })),

        modalClear: () => set((state) => ({
          targetInfo: [],
          targetSurvey: [],
        })),

        resultClear: () => set((state) => ({
          resultList: [],
          surveyAssigned: {},
          familyInfo: {},
          surveyInfoList: [],
        })),
      }),

      { name: 'stressStore' },
    ),
  ),
)

export default useStressStore;
